module.exports = {"primaryEndpoint":"api","secondaryEndpoint":"api","basicSubmitParams":{"client_source":"WWW","agent_id":2,"template":2,"requested_period":"dd","requested_time":30,"client_type":0},"transactionlinkLib":"https://widget.transactionlink.io/transactionlink-widget.umd.js","transactionlinkMode":"","transactionlinkWorkspaceKey":"qZMlZ5cV0kGYODqorLATH1hsW3YNEzTv","kontomatikClient":"minicredit","kontomatikClientTest":"minicredit-test","min_amount":500,"min_tenor":1,"default_amount":3000,"default_tenor":30,"tenor_sign":"d"}


//////////////////
// WEBPACK FOOTER
// ./src/conf/config.json
// module id = m8uw
// module chunks = 9